import { useEffect, useMemo, useRef, useState } from "react";

import { cn } from "../lib/utils";

export function PartnerCarousel({
  categories,
  className,
}) {
  const [active, setActive] = useState(0);
  const intervalRef = useRef(null);

  const partners = useMemo(() => categories[active]?.partners ?? [], [active, categories]);

  useEffect(() => {
    if (intervalRef.current) window.clearInterval(intervalRef.current);
    intervalRef.current = window.setInterval(() => {
      setActive((i) => (i + 1) % categories.length);
    }, 3500);

    return () => {
      if (intervalRef.current) window.clearInterval(intervalRef.current);
    };
  }, [categories.length]);

  return (
    <div className={cn("space-y-4", className)}>
      <div className="flex flex-wrap items-center gap-2">
        {categories.map((c, idx) => (
          <button
            key={c.title}
            type="button"
            onClick={() => setActive(idx)}
            className={cn(
              "focus-ring rounded-full border border-border-subtle px-3 py-1 text-xs font-semibold",
              idx === active
                ? "bg-white/10 text-text-primary"
                : "bg-transparent text-text-secondary hover:bg-white/5 hover:text-text-primary",
            )}
          >
            {c.title}
          </button>
        ))}
      </div>

      <div className="relative overflow-hidden rounded-2xl border border-border-subtle bg-white/3">
        <div className="pointer-events-none absolute inset-0 opacity-40" style={{ background: "var(--gradient-card-hover)" }} />
        <div className="flex gap-6 px-6 py-6">
          {partners.map((p) => (
            <div
              key={p}
              className="rounded-xl border border-border-subtle bg-white/4 px-4 py-3 text-sm font-semibold text-text-secondary grayscale transition-all hover:bg-white/8 hover:text-text-primary hover:grayscale-0"
            >
              {p}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
